import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { PenLine, ImagePlus } from "lucide-react";
import { apiFetch } from "api";
import './CreatePost.sass';

export default function CreatePostForm() {
    const { leagueId } = useParams();
    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [mainText, setMainText] = useState("");
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0] || null;
        setFile(selectedFile);
        setPreview(selectedFile ? URL.createObjectURL(selectedFile) : null);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);

        const formData = new FormData();
        formData.append("title", title);
        formData.append("mainText", mainText);
        if (file) formData.append("image", file);

        try {
            const res = await apiFetch(`/league/${leagueId}/posts`, {
                method: "POST",
                body: formData,
            });

            if (!res.ok) throw new Error("Misslyckades att skapa inlägg");

            setSuccess(true);
            setTimeout(() => navigate(`/league/${leagueId}/posts`), 1000);
        } catch (err) {
            setError("Något gick fel. Försök igen.");
            console.error("Error creating post:", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="page create-post">
            <div className="section-header">
                <div className="sub-header sub-header--with-img">
                    <PenLine size="20" />
                    <h2>Skapa inlägg</h2>
                </div>
            </div>

            <div className="create-post__card">
                <form onSubmit={handleSubmit}>
                    <div className="create-post__field">
                        <label htmlFor="title">Rubrik</label>
                        <input
                            id="title"
                            name="title"
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </div>

                    <div className="create-post__field">
                        <label htmlFor="mainText">Text</label>
                        <textarea
                            id="mainText"
                            name="mainText"
                            value={mainText}
                            onChange={(e) => setMainText(e.target.value)}
                            required
                        />
                    </div>

                    <div className="create-post__field">
                        <label>Bild</label>
                        <label className="create-post__file-label">
                            <ImagePlus size={15} />
                            Välj bild
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleFileChange}
                            />
                        </label>
                        {file && <span className="create-post__file-name">{file.name}</span>}
                    </div>

                    {preview && (
                        <div className="create-post__preview">
                            <img src={preview} alt="Förhandsgranskning" />
                        </div>
                    )}

                    {error && <p className="create-post__error">{error}</p>}
                    {success && <p className="create-post__success">Inlägg skapat!</p>}

                    <div className="create-post__actions">
                        <button
                            className="button button--save"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "Sparar..." : "Publicera"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
